import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

@Injectable({
  providedIn:'root'
})

export class RequestService{
  api = environment.apiUrl
  constructor(
    private http:HttpClient
  ){}
  submit(data:any):Observable<any>{
    return this.http.post<any>(`${this.api}api/users/forms`,data)
  }
}
